import "core-js/modules/es.array.push.js";
import { ref, computed, getCurrentInstance } from 'vue';
import auth from '@/plugins/auth-service.js';
import { useUiTheme } from '@/composables/useUiTheme';
import DefaultPhotoSmall from '@/assets/images/faces/default-user-small.svg';
import useUserStore from '@/composables/useUserStore';
import useCompanies from '@/composables/useCompanies.query';
import { useI18n } from '@/plugins/i18n';
import { useRouter } from 'vue-router/composables';
export default {
  __name: 'SidebarProfileDropdownBody',
  props: {
    userPhoto: {
      type: String
    },
    userName: {
      type: String
    },
    userRole: {
      type: String
    }
  },
  emits: ['chooseProfileItem', 'chooseCompanyItem'],
  setup(__props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const {
      preference: currentTheme,
      set: setTheme
    } = useUiTheme();
    const router = useRouter();
    const instance = getCurrentInstance();
    const bvModal = instance.proxy.$bvModal;
    const logoutLoading = ref(false);
    const {
      companyId: currentCompanyId
    } = useUserStore();
    const {
      result: companies
    } = useCompanies();
    const defaultCompanyId = computed(() => {
      return process.env.VUE_APP_DEFAULT_COMPANY_ID;
    });
    const userCompanies = computed(() => {
      return companies.value;
    });
    const mainCompanies = computed(() => {
      return userCompanies.value?.filter(item => item.id !== defaultCompanyId.value) || [];
    });
    const defaultCompany = computed(() => {
      return userCompanies.value?.find(item => item.id === defaultCompanyId.value);
    });
    const profilePagesItems = computed(() => {
      return [{
        title: t('sidebar.titles.profile'),
        routeName: 'SettingsProfile'
      }, {
        title: t('sidebar.titles.password'),
        routeName: 'Password'
      }];
    });
    function checkIsCurrentCompany(id) {
      return id === currentCompanyId.value;
    }
    async function updateCurrentCompany(companyId) {
      try {
        auth.changeTenantId(companyId);
        await router.push({
          name: 'WorkCenters'
        });
      } catch (e) {
        console.log(e);
      } finally {
        router.go();
      }
    }
    function openNewCompanyModal() {
      bvModal.show('newCompanyModal');
    }
    async function companyCreated(companyId) {
      await updateCurrentCompany(companyId);
    }
    function chooseProfileItem() {
      emit('chooseProfileItem');
    }
    async function logout() {
      if (logoutLoading.value) {
        return;
      }
      logoutLoading.value = true;
      await auth.signoutRedirect();
      logoutLoading.value = false;
    }
    return {
      __sfc: true,
      emit,
      t,
      currentTheme,
      setTheme,
      router,
      instance,
      bvModal,
      logoutLoading,
      currentCompanyId,
      companies,
      defaultCompanyId,
      userCompanies,
      mainCompanies,
      defaultCompany,
      profilePagesItems,
      checkIsCurrentCompany,
      updateCurrentCompany,
      openNewCompanyModal,
      companyCreated,
      chooseProfileItem,
      logout,
      DefaultPhotoSmall
    };
  }
};